<div
  class="flex align-items-center justify-content-start border-radius background-white"
  [ngClass]="{
    'border--error': hasError,
    'border-empty': !havePhoneCodeValue() || !phoneNumber || phoneNumber === '',
    'border-selected': havePhoneCodeValue() || (phoneNumber && phoneNumber !== '')
  }"
>
  <div class="flex border--right-stroke">
    <div *ngIf="showFlag" class="phone-component--flag">
      <img [src]="flag" class="border-empty" />
    </div>
    <div class="phone-component" #anSelect>
      <!-- readonly -->
      <div
        class="phone-component--selected"
        #inputElement
        [style.height]="inputHeight + 'rem'"
        [style.width]="inputWidth + 'rem'"
        (click)="selectDropdown_toggle(); onTouchCallback()"
      >
        <div *ngIf="valuesSelected_get_first()" class="phone-component--selected--text font--xxl-14">
          <div class="phone-component--selected--text--first font--xxl-14 wrap--1-line">
            +{{ valuesSelected_get_first() }}
          </div>
        </div>
        <div *ngIf="!valuesSelected_get_first()" class="phone-component--selected--placeholder">
          <div class="phone-component--selected--text--first wrap--1-line font--xxl-14 text-center font-blue">
            {{ valuePlaceholder }}
          </div>
        </div>
        <div class="phone-component--selected--drop" [ngClass]="{ expanded: selectDropdown_show }"></div>
      </div>
      <div
        *ngIf="selectDropdown_show"
        #selectDropdown
        class="phone-component--dropdown phone-component--dropdown--{{ position }}"
        [style.top]="position === 'up' ? inputHeight + 'rem' : ''"
        [style.bottom]="position === 'down' ? inputHeight + 'rem' : ''"
      >
        <div *ngIf="filter_field" class="phone-component--dropdown--search">
          <input
            type="text"
            class="font--xxl-13"
            #inputFilterElement
            placeholder="Search by name..."
            (keyup)="dropdownItem_filter($event)"
            autocomplete="new-password"
          />
        </div>
        <cdk-virtual-scroll-viewport itemSize="50" class="phone-component--dropdown--content">
          <div
            *cdkVirtualFor="let country of countries"
            class="phone-component--dropdown--content--option"
            [ngClass]="{ 'background-grey font-weight--500': dropdownItem_selected(country[objectKey]) }"
            (click)="dropdownItem_select(country, $event)"
          >
            <div class="flex align-items-center justify-content-start margin-xxl--left-4">
              <img style="height: 1.5rem; width: 2.5rem" [src]="sanatizeFlag(country.flag)" />
              <label class="checkbox margin-xxl--left-20">
                <input type="checkbox" [checked]="dropdownItem_selected(country[objectKey])" />
                <span class="checkbox--checkmark checkbox--checkmark--red-middle"></span>
                <span
                  class="checkbox--text wrap--1-line font--xxl-13 font-blue"
                  [ngClass]="{ 'font-bold font-grey': dropdownItem_selected(country[objectKey]) }"
                  >+{{ country[objectValue] }}</span
                >
              </label>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>
  <input
    [(ngModel)]="phoneNumber"
    class="input-phone font--xxl-14 color-black font-regular"
    [style.width.rem]="showFlag ? 13 : 7"
    style="border: none"
    placeholder="Phone number"
    type="number"
    [readonly]="isDisabled"
    autocomplete="new-password"
    (ngModelChange)="formatPhone()"
  />
</div>
